module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer",
    class: this.$route.meta.white ? 'white' : ''
  }, [_c('div', {
    staticClass: "wrapper"
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "faq"
    }
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('ul', [_vm._l((_vm.fMenu), function(menu) {
    return _c('li', [_c('dl', [_c('dt', [_vm._v(_vm._s(menu.name))]), _vm._v(" "), _vm._l((menu.children), function(child) {
      return _c('dd', [_c('i'), _vm._v(" "), (!child.router.path) ? _c('a', {
        attrs: {
          "href": child.router,
          "title": child.name
        }
      }, [_vm._v(_vm._s(child.name))]) : _c('router-link', {
        attrs: {
          "to": child.router,
          "title": child.name
        }
      }, [_vm._v(_vm._s(child.name))])], 1)
    })], 2)])
  }), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })], 2)])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "footer"
    }
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('p', [_vm._v("\n        ©2015-现在 kxymall.com 版权所有 闽ICP备2023007687号\n        "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": require('../../../assets/images/yyzz.jpg')
    }
  }, [_vm._v("营业执照")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "300px",
      "margin": "0 auto",
      "padding": "20px 0 0 0"
    }
  }, [_c('a', {
    staticStyle: {
      "display": "inline-block",
      "text-decoration": "none",
      "height": "20px",
      "line-height": "20px"
    },
    attrs: {
      "target": "_blank",
      "href": require('../../../assets/images/zzdx.jpg')
    }
  }, [_c('p', {
    staticStyle: {
      "float": "left",
      "height": "20px",
      "line-height": "20px",
      "margin": "0px 0px 0px 5px"
    }
  }, [_vm._v("\n            增值电信业务经营许可证\n          ")])])]), _vm._v(" "), _vm._m(0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "300px",
      "margin": "0 auto",
      "padding": "20px 0"
    }
  }, [_c('a', {
    staticStyle: {
      "display": "inline-block",
      "text-decoration": "none",
      "height": "20px",
      "line-height": "20px"
    },
    attrs: {
      "target": "_blank",
      "href": "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=35020602002793"
    }
  }, [_c('img', {
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "src": require("../../../assets/images/备案图标.png")
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "float": "left",
      "height": "20px",
      "line-height": "20px",
      "margin": "0px 0px 0px 5px",
      "color": "#939393"
    }
  }, [_vm._v("\n            闽公网安备 35020602002793号\n          ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5f860c6a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/common/layout/footer.vue
// module id = 1613
// module chunks = 1